import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimespanComponent } from './timespan-component/timespan.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@NgModule({
    imports: [
        CommonModule,
        NgxSliderModule,
    ],
    declarations: [
        TimespanComponent,
    ],
    exports: [
        TimespanComponent,
    ],
})
export class endooSpotWidgetsModule { }
